import { LoadingButton } from '@mui/lab';
import { Card, Container, Stack, TextField, Typography } from '@mui/material';
import { useFormik } from 'formik';
import { get } from 'lodash';
import { ComponentType } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { ROUTES } from 'src/constants/routes';
import { useRouter } from 'src/hooks';
import { authLogin } from 'src/thunks/auth-thunks';
import * as yup from 'yup';
import useStyles from './styles';

export const Login: ComponentType = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const router = useRouter();

  const handleSubmit = () => {
    authLogin(formik.values)(dispatch).then(() => router.push(ROUTES.CABINET));
  };

  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
    },
    validationSchema: yup.object().shape({
      email: yup.string().required('error.required').trim(),
      password: yup.string().required('error.required').trim(),
    }),
    onSubmit: handleSubmit,
  });

  const hasError = (field: string) => {
    return (
      get(formik, ['touched', ...field.split('.')], false) &&
      Boolean(get(formik, ['errors', ...field.split('.')], false))
    );
  };

  const getErrorMessage = (field: string) => {
    if (!hasError(field)) return ' ';
    const key = get(formik, ['errors', ...field.split('.')], 'error');
    if (key.includes('error.')) {
      return t(key, 'Ошибка');
    }
    return key;
  };

  return (
    <Stack className={classes.root} direction="row">
      <Container maxWidth="xs" sx={{ py: 10 }}>
        <Card sx={{ p: 4 }}>
          <Typography variant="h1" mb={3}>
            {t('authorization', 'Авторизация')}
          </Typography>
          <form onSubmit={formik.handleSubmit}>
            <TextField
              {...formik.getFieldProps('email')}
              label={t('email', 'E-mail')}
              error={hasError('email')}
              helperText={getErrorMessage('email')}
              fullWidth
            />
            <TextField
              {...formik.getFieldProps('password')}
              label={t('password', 'Пароль')}
              error={hasError('password')}
              helperText={getErrorMessage('password')}
              type="password"
              fullWidth
            />
            <Stack direction="row" justifyContent="flex-end" mt={2}>
              <LoadingButton variant="contained" onClick={formik.submitForm} type="submit">
                {t('login', 'Войти')}
              </LoadingButton>
            </Stack>
          </form>
        </Card>
      </Container>
    </Stack>
  );
};
